module.exports = __webpack_public_path__ + "img/syukyaku-EC-websit-002sp.d34902c7.jpg";